import family from 'media/images/category-family.png';
import forHer from 'media/images/category-for-her.png';
import forHim from 'media/images/category-for-him.png';
import hobbies from 'media/images/category-hobbies.png';
import science from 'media/images/category-science.png';
import business from 'media/images/category-business.png';

export const getImageCategoriesById = (id: number) => {
  switch (id) {
    case 150: return forHer;
    case 151: return forHim;
    case 160: return hobbies;
    case 158: return business;
    case 159: return science;
    case 153: return family;
    default: return null;
  }
};
